export default {
    data() {
        return {}
    },
    mounted() {
    },
    methods: {
        async readAllVoucher(device_tag, merchant_id = "", page = 1, per_page = 50) {
            const response = await this.$api.default.get("voucher/read-all", {
                "merchant_id": merchant_id,
                "device_tag": device_tag,
                "page": page,
                "per-page": per_page,
            });

            if (response.status === "failed") {
                this.$toast.errorResponse(response);
                return false;
            }

            return response.data;
        },

        async readVoucherDetail(voucher_short_id) {
            const response = await this.$api.default.get("voucher/read-one", {
                voucher_short_id: voucher_short_id
            });

            if (response.status === "failed") {
                this.$toast.errorResponse(response);
                return false;
            }

            return response.data;
        },

        async updatePageView(voucher_id) {
            const response = await this.$api.default.post("api/update-page-views", {
                voucher_id: voucher_id
            });

            if (response.status === "failed") {
                this.$toast.errorResponse(response);
                return false;
            }

            return response.data;
        },

        async collectVoucher(device_tag, voucher_id) {
            const response = await this.$api.default.post("voucher/collect", {
                device_tag: device_tag,
                voucher_id: voucher_id,
            });

            if (response.status === "failed") {
                this.$toast.errorResponse(response);
                return false;
            }

            return response.data;
        },

        async readAllRecordHomepage(device_tag) {
            const response = await this.$api.default.get("record/fetch-for-homepage", {
                device_tag: device_tag
            });

            if (response.status === "failed") {
                this.$toast.errorResponse(response);
                return false;
            }

            return response.data;
        },

        async readAllRecord(device_tag = null, voucher_id = null, filter_status = "VALID", sort_by = "EXPIRED_DATE", page = 1, per_page = 100) {
            var params = {
                "page": page,
                "per-page": per_page,
            }

            if (device_tag) {
                params.device_tag = device_tag;
            }

            if (voucher_id) {
                params.voucher_id = voucher_id;
            }

            if (filter_status) {
                params.filter_status = filter_status;
            }

            if (sort_by) {
                params.sort_by = sort_by;
            }

            const response = await this.$api.default.get("record/read-all", params);

            if (response.status === "failed") {
                this.$toast.errorResponse(response);
                return false;
            }

            return response.data;
        },


        async readExpiredRecord(device_tag) {
            const response = await this.$api.default.get("record/fetch-expired", {
                device_tag: device_tag,
            });

            if (response.status === "failed") {
                this.$toast.errorResponse(response);
                return false;
            }

            return response.data;
        },

        async readRecordDetail(device_tag, record_id) {
            const response = await this.$api.default.get("record/read-one", {
                device_tag: device_tag,
                record_id: record_id
            });

            if (response.status === "failed") {
                this.$toast.errorResponse(response);
                return false;
            }

            return response.data;
        },

        async redeemRecord(device_tag, record_id) {
            const response = await this.$api.default.post("record/redeem", {
                device_tag: device_tag,
                record_id: record_id
            });

            if (response.status === "failed") {
                this.$toast.errorResponse(response);
                return false;
            }

            return response.data;
        },

        async createVoucherLink(device_tag, voucher_short_id) {
            const response = await this.$api.default.post("api/create-linking", {
                device_tag: device_tag,
                voucher_short_id: voucher_short_id
            });

            if (response.status === "failed") {
                // this.$toast.errorResponse(response);
                return false;
            }

            return response.data;
        },

        async generateQr(url) {
            const response = await this.$api.default.get("qr-code/generate", {
                url: url,
            });

            if (!response) {
                this.$toast.error("Failed to generate QR code");
                return false;
            }

            return response;
        },


        // Payment
        async getMerchantPaymentMethod(merchant_id) {
            const response = await this.$api.default.get("plugin/get-payment-method-list", {
                merchant_id: merchant_id,
            });

            if (response.status === "failed") {
                this.$toast.errorResponse(response);
                return false;
            }

            return response.data;
        },

        async checkPaymentStatus(gateway_order_id, is_need_details = true, order_id = "EVS_WEB_UI") {
            const response = await this.$api.default.get("plugin/get-payment-method-list", {
                order_id: order_id,
                gateway_order_id: gateway_order_id,
                is_need_details: is_need_details,
            });

            if (response.status === "failed") {
                this.$toast.errorResponse(response);
                return false;
            }

            return response.data;
        },


        // Merchant Redeem
        async updateRecordStatus(record_id, passcode, selected_status = "APPROVE") {
            const response = await this.$api.default.post("record/approval", {
                record_id: record_id,
                passcode: passcode,
                selected_status: selected_status,
            });

            if (response.status === "failed") {
                this.$toast.errorResponse(response);
                return false;
            }

            return response.data;
        },

        //! Deprecate this after merchant v2 done
        async updateRecordStatusTemp(record_id, passcode, selected_status = "APPROVE") {
            const response = await this.$api.default.post("merchant/record-approval-tmp", {
                record_id: record_id,
                passcode: passcode,
                selected_status: selected_status,
            });

            if (response.status === "failed") {
                this.$toast.errorResponse(response);
                return false;
            }

            return response.data;
        },
    }
}